/*eslint-disable*/export const messages=JSON.parse("{\"breadcrumbs.ariaLabel\":[\"Olet tässä\"]}");